import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { PureDataComponent } from '@aytm/lib/common/components/pure-component'

import '@aytm/lib/rfd-ui/styles/advanced/paginator.scss'

export default class Pagination extends PureDataComponent {
  static propTypes = {
    page: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    prefix: PropTypes.string,
    separator: PropTypes.string,
    disabled: PropTypes.bool,
    onPageChange: PropTypes.func.isRequired
  }

  constructor(...args) {
    super(...args);
    this.onChange = this.onChange.bind(this);
  }

  onChange(index) {
    const { total, onPageChange } = this.props
    return null == index || 1 > index || total < index || 'function' != typeof onPageChange
      ? null
      : () => {
          onPageChange(index)
          return false
        }
  }

  render() {
    const { page, total, prefix = '', separator = ' of ', disabled } = this.props

    return (
      <div className="rfd-ui-paginator">
        {total > 1 && (
          <span>
            <span
              className={classNames('rfd-ui-paginator-el', 'left', {
                disabled: disabled || 1 == page
              })}
              onClick={disabled ? null : this.onChange(page - 1)}
            >
              <i className="icon-aytmfd-prev" />
            </span>
            <span className="rfd-ui-paginator-el">
              {' '}
              {prefix}
              {page + separator + total}{' '}
            </span>
            <span
              className={classNames('rfd-ui-paginator-el', 'right', {
                disabled: disabled || page == total
              })}
              onClick={disabled ? null : this.onChange(page + 1)}
            >
              <i className="icon-aytmfd-next" />
            </span>
          </span>
        )}
      </div>
    )
  }
}
